<ngx-charts-chart [view]="[width, height]" [showLegend]="false" [animations]="animations">
  <svg:g *ngIf="dims" [attr.transform]="transform" class="heatmap-chart chart">
    <svg:g
      ngx-charts-x-axis
      [xScale]="xScale"
      [dims]="dims"
      [showGridLines]="false"
      [showLabel]="false"
      [trimTicks]="false"
      [rotateTicks]="true"
      [tickFormatting]="formattaParametro"
      (dimensionsChanged)="updateXAxisHeight($event)"
    ></svg:g>
    <svg:g
      ngx-charts-y-axis
      [yScale]="yScale"
      [dims]="dims"
      [showGridLines]="false"
      [showLabel]="false"
      [trimTicks]="false"
      (dimensionsChanged)="updateYAxisWidth($event)"
    ></svg:g>

    <svg:rect
      *ngFor="let rect of rects"
      [attr.x]="rect.x"
      [attr.y]="rect.y"
      [attr.width]="rect.width"
      [attr.height]="rect.height"
      [attr.fill]="rect.fill"
    >
      <svg:title>{{ titoloCella(rect.cella) }}</svg:title>
    </svg:rect>
  </svg:g>
</ngx-charts-chart>
